// Fix google translate causing node duplication
const ib = Element.prototype.insertBefore;
Element.prototype.insertBefore = function(child, ref) {
	if (ref && ref.localName === 'font') {
		child.innerText = ref.innerText;
		return;
	}
	return ib.apply(this, arguments);
};